// we don't care about the response here, as it's handled by graphql error management system
export const NOOP_graphqlErrorManagement = () => undefined;
